// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCACbRDeA4R635J2s5gajxBRZFJZg-jnx0",
  authDomain: "sawbona-app.firebaseapp.com",
  projectId: "sawbona-app",
  storageBucket: "sawbona-app.firebasestorage.app",
  messagingSenderId: "473710798109",
  appId: "1:473710798109:web:ee8233de94535402182df4",
  measurementId: "G-HZKESHS4EN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app);

export { app, db, storage, auth, functions };
